<!-- **
  * name1 value1 name2 value2
* -->
<template>
  <div :class="classObject">
    <div v-for="(v, index) in listData" :key="`${v.name}-${index}`">
      <div
        v-if="!combineNameUnit"
        class="itemName"
        :style="{
          color: v.colorName ?? v.colorName,
          fontSize: v.fontSize ?? v.fontSize,
        }"
        :title="v.name"
      >
        {{ v.name }}
      </div>
      <div
        v-else-if="!!v.unit"
        class="itemName"
        :style="{
          color: v.colorName ?? v.colorName,
          fontSize: v.fontSize ?? v.fontSize,
        }"
        :title="`${v.name}(${v.unit})`"
      >
        {{ `${v.name}(${v.unit})` }}
      </div>
      <div
        v-else
        class="itemName"
        :style="{
          color: v.colorName ?? v.colorName,
          fontSize: v.fontSize ?? v.fontSize,
        }"
        :title="v.name"
      >
        {{ v.name }}
      </div>
      <div
        v-if="!combineNameUnit && !!v.unit"
        class="itemUnit"
        :style="{ color: v.colorUnit ?? v.colorUnit }"
      >
        ({{ v.unit }})
      </div>

      <div
        class="itemValue"
        :style="{ marginLeft: 10, color: v.colorValue ?? v.colorValue }"
        :title="v.value"
      >
        {{ dealBigNum(v.value) }}
      </div>
    </div>
  </div>
</template>

<script>
const classNames = require("classnames");
import { dealBigNum } from "@/assets/js/utils";
export default {
  name: "TipsWrap",
  props: {
    listData: {
      type: Array,
      default: () => [
        {
          name: "开启",
          value: 0,
          colorValue: "#28CCCB",
        },
        {
          name: "关闭",
          value: 0,
        },
      ],
    },
    className: {
      type: String,
      default: "",
    },
    combineNameUnit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classObject: function () {
      return classNames({
        TipsWrap: true,
        [this.className]: !!this.className,
      });
    },
  },
  methods: {
    dealBigNum,
  },
};
</script>

<style lang="scss" scoped>
.TipsWrap {
  @include setFlexColumn;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  & > div {
    color: #000;
    display: flex;
    width: 80%;
    height:35px;
    margin-top: 5px;

    .itemName {
      width: 60px;
      min-width: 60px;
    }

    .itemValue {
      font-weight: bold;
      max-width: 150px;
      margin-left: 5px;
      @include setEllipsis;
    }
  }
}
</style>
